const defaultRedirectPath = "/";

export function resolveSafeAppRedirectPath(value: string | null | undefined): string {
  if (!value?.startsWith("/") || value.startsWith("//")) {
    return defaultRedirectPath;
  }

  try {
    const url = new URL(value, "https://tcos.local");

    if (url.origin !== "https://tcos.local" || url.pathname.startsWith("//")) {
      return defaultRedirectPath;
    }

    return `${url.pathname}${url.search}${url.hash}`;
  } catch {
    return defaultRedirectPath;
  }
}

export function getRedirectPath(searchParams: URLSearchParams): string {
  return resolveSafeAppRedirectPath(
    searchParams.get("redirect_to") ?? searchParams.get("return_to") ?? searchParams.get("next")
  );
}
